const formatOptions = {
    standard: {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    },
    numeric: {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
    },
    shortNumeric: {
        month: 'numeric',
        day: 'numeric',
        year: '2-digit',
    },
    shortNumericNoYear: {
        month: 'numeric',
        day: 'numeric',
    },
} as const

type FormatOptions = {
    type: 'standard' | 'numeric' | 'shortNumeric' | 'shortNumericNoYear'
}

const dateRegexp = new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/)

const testDate = (dateString: string): boolean => dateRegexp.test(dateString)

const malformedDateRegexp = new RegExp(/^([12]\d{3}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01]))$/)

const testMalformedDate = (dateString: string): boolean => malformedDateRegexp.test(dateString)

/**  This function ignores timestamps!!  If timestamps precision is needed, use a date constructor directly. */
export const formatDate = (dateString?: string | null, { type }: FormatOptions = { type: 'standard' }): string => {
    if (!dateString) return ''

    let year: number, month: number, day: number

    if (testDate(dateString)) {
        // Handle properly formatted date strings in YYYY-MM-DD format
        const parts = dateString.split('-')
        year = parseInt(parts[0], 10)
        month = parseInt(parts[1], 10) - 1
        day = parseInt(parts[2], 10)
    } else if (testMalformedDate(dateString)) {
        // Handle malformed date strings in YYYYMMDD format (e.g. 20240131)
        year = parseInt(dateString.substring(0, 4), 10)
        month = parseInt(dateString.substring(4, 6), 10) - 1
        day = parseInt(dateString.substring(6, 8), 10)
    } else {
        // Try parsing as any other date format
        const date = new Date(dateString)
        if (isNaN(date.getTime())) return ''
        return date.toLocaleDateString(undefined, formatOptions[type])
    }

    // Create date and validate in one step - Date constructor handles all edge cases
    const date = new Date(year, month, day)

    // Check if date is valid and matches input (Date auto-corrects invalid dates, so verify)
    if (isNaN(date.getTime()) || date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) {
        return ''
    }

    return date.toLocaleDateString(undefined, formatOptions[type])
}
